/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
import { EventEmitter } from './events.js';
import { v4 as uuid } from 'uuid';
export default class SharedContext {
    constructor(_context) {
        this._context = _context;
        this._events = new EventEmitter();
        // Save initial context state
        this._context = _context;
        // Generate a GUID to identify shared context instance
        this.referenceId = uuid();
    }
    getContext() {
        return this._context;
    }
    on(event, listener) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this._events.on(event, listener);
        return this;
    }
    off(event, listener) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this._events.off(event, listener);
        return this;
    }
    updateContext(context) {
        // Merge updated context object into existing context
        this._context = Object.assign(Object.assign({}, this._context), context);
        // Emit change to update all modules sharing this context instance
        this._events.emit('change');
    }
}
